import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/Explorer/Nodes/NewCopyRender.tsx";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
import { useBaseRenderProps } from "../BaseRenderProps";
import { closeItemForm } from "../Model";
import { NodeNameForm } from "../NodeNameForm";
import { useGlobalPending } from "../PendingContext";
import { jsx as _jsx } from "react/jsx-runtime";
export var NewCopyRender = /*#__PURE__*/React.memo(function (_ref) {
  var id = _ref.id,
      type = _ref.type,
      originalName = _ref.originalName,
      defaultName = _ref.defaultName;

  var _ref2 = useBaseRenderProps() || {},
      _ref2$entityIcon = _ref2.entityIcon,
      entityIcon = _ref2$entityIcon === void 0 ? null : _ref2$entityIcon,
      _ref2$assemblyIcon = _ref2.assemblyIcon,
      assemblyIcon = _ref2$assemblyIcon === void 0 ? null : _ref2$assemblyIcon,
      onCopy = _ref2.onCopy;

  var _useGlobalPending = useGlobalPending(),
      pending = _useGlobalPending.pending,
      ifPromise = _useGlobalPending.ifPromise;

  var _React$useState = React.useState(defaultName),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      name = _React$useState2[0],
      setName = _React$useState2[1];

  var onChange = React.useCallback(function (e) {
    return setName(e.currentTarget.value);
  }, []);
  var onSubmit = React.useCallback(function (_, name) {
    if (onCopy) {
      var _ifPromise;

      (_ifPromise = ifPromise('copyEntity', onCopy({
        id: id,
        name: name,
        type: type
      }))) === null || _ifPromise === void 0 ? void 0 : _ifPromise.then(closeItemForm);
    }
  }, [id, type, ifPromise, onCopy]);
  var icon = type === 'Entity' ? entityIcon : assemblyIcon;
  return icon && /*#__PURE__*/_jsx(NodeNameForm, {
    icon: icon,
    pending: pending.copyEntity,
    submitDisabled: name === originalName,
    onChange: onChange,
    defaultName: defaultName,
    onClose: closeItemForm,
    onSubmit: onSubmit
  });
});
NewCopyRender.displayName = 'NewCopyRender';